import * as React from "react";

import classnames from "classnames";
import { CloseOutline24 } from "@carbon/icons-react";
import { Button } from "carbon-components-react";

import { HurdleProps } from "underwriter_dashboard/HurdleEditor";

const styles = require("./styles.module.scss");

interface HurdleViewProps extends HurdleProps {
  children: any;
  className?: string;
  contentClassName?: string;
}

const HurdleView: React.FunctionComponent<HurdleViewProps> = ({
  children,
  hurdle,
  onHide = () => {},
  className,
  contentClassName,
  hideTitle,
}) => {
  React.useEffect(() => {
    // Ensure we always start at top:
    return window.scrollTo({ top: 0 });
  }, []);

  const contentClasses = classnames({
    [styles.hurdleContent]: true,
    [styles.hurdleContentWithPadding]: !!hideTitle,
  });

  return (
    <div className={classnames(styles.container, className)}>
      <div className={classnames(styles.content, contentClassName)}>
        {!hideTitle && (
          <div className={styles.title}>
            <h3>{hurdle.name}</h3>
            <Button
              onClick={onHide}
              hasIconOnly
              kind="ghost"
              size="sm"
              iconDescription="Close"
              tooltipPosition="bottom"
              tooltipAlignment="end"
            >
              <CloseOutline24 style={{ fill: "gray" }} />
            </Button>
          </div>
        )}
        <div className={contentClasses}>{children}</div>
      </div>
    </div>
  );
};

export default HurdleView;
